import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: true,
  isDeleteDialogOpen: false,
  statesList: [],
  crewMemberData: [],
  deleteRowIndex: null,
  crewMemberIdToDelete: null,
};

const userFormCrewMemberSlice = createSlice({
  name: 'userFormCrewMember',
  initialState: initialState,
  reducers: {
    setUserCrewMember(state, { payload }) {
      state.isLoading = Object.prototype.hasOwnProperty.call(
        payload,
        'isLoading'
      )
        ? payload.isLoading
        : state.isLoading;
      state.crewMemberData = Object.prototype.hasOwnProperty.call(
        payload,
        'crewMemberData'
      )
        ? payload.crewMemberData
        : state.crewMemberData;
      state.crewMemberDataCount = Object.prototype.hasOwnProperty.call(
        payload,
        'crewMemberDataCount'
      )
        ? payload.crewMemberDataCount
        : state.crewMemberDataCount;
      state.isDeleteDialogOpen = Object.prototype.hasOwnProperty.call(
        payload,
        'isDeleteDialogOpen'
      )
        ? payload.isDeleteDialogOpen
        : state.isDeleteDialogOpen;
      state.deleteRowIndex = Object.prototype.hasOwnProperty.call(
        payload,
        'deleteRowIndex'
      )
        ? payload.deleteRowIndex
        : state.deleteRowIndex;
      state.crewMemberIdToDelete = Object.prototype.hasOwnProperty.call(
        payload,
        'crewMemberIdToDelete'
      )
        ? payload.crewMemberIdToDelete
        : state.crewMemberIdToDelete;
    },
  },
});

export const { setUserCrewMember } = userFormCrewMemberSlice.actions;

export const userFormCrewMemberReducer = userFormCrewMemberSlice.reducer;
